export default __webpack_public_path__ + "static/media/pcos_logo.a7f9b012.png";